<template>
    <div class="row">
        <div
            v-if="eligibility?.health_Benefit_Plan_Coverage.success == 'Yes'"
            :class="`py-3 row ${
                eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers.length > 1 ? 'col-12' : 'col-6'
            }`"
        >
            <h6 class="col-12">
                <i class="fas fa-money-check-alt text-app-primary"></i> Health Benefit Plan Coverage Payers
            </h6>
            <div
                v-if="eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers"
                v-for="coveragePayer of eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers"
                :key="coveragePayer.reference_id"
                :class="`${
                    eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers.length > 1
                        ? 'col-12 col-md-6 col-lg-4'
                        : 'col-12'
                }`"
            >
                <div class="border bg-white p-2 mt-2 h-100">
                    <h6>
                        <span v-if="coveragePayer.name">{{ coveragePayer.payer }}: {{ coveragePayer.name }}</span>
                        <span v-if="coveragePayer.insurance_type">, {{ coveragePayer.insurance_type }}</span>
                    </h6>
                    <p class="my-1" v-if="coveragePayer.reference_id">
                        {{ coveragePayer.reference_id_qualifier }}: {{ coveragePayer.reference_id }}
                    </p>
                    <p class="my-1" v-if="coveragePayer.date">
                        <i class="fas fa-calendar-alt"></i> {{ coveragePayer.date }}
                    </p>
                    <p
                        class="my-1"
                        v-if="coveragePayer.address1 || coveragePayer.city || coveragePayer.state || coveragePayer.zip"
                    >
                        <i class="fas fa-address-book"></i>
                        {{ coveragePayer.address1 }}, {{ coveragePayer.city }}, {{ coveragePayer.state }},
                        {{ coveragePayer.zip }}
                    </p>
                    <p class="my-1" v-if="coveragePayer.phone">
                        <i class="fas fa-mobile-alt"></i>
                        <a :href="`tel:${coveragePayer.phone}`">{{ formatPhoneNumber(coveragePayer.phone) }}</a>
                    </p>
                </div>
            </div>
        </div>
        <div
            v-if="eligibility?.medicareAdvantage.success == 'Yes'"
            :class="`py-3 row ${eligibility.medicareAdvantage.medicareAdvantagePayers.length > 1 ? 'col-12' : 'col-6'}`"
        >
            <h6 class="col-12"><i class="fas fa-money-check-alt text-app-primary"></i> Medicare Advantage Payers</h6>
            <div
                v-if="eligibility.medicareAdvantage.medicareAdvantagePayers"
                v-for="advantagePayer of eligibility.medicareAdvantage.medicareAdvantagePayers"
                :key="advantagePayer.reference_id"
                :class="`${
                    eligibility.medicareAdvantage.medicareAdvantagePayers.length > 1
                        ? 'col-12 col-md-6 col-lg-4'
                        : 'col-12'
                }`"
            >
                <div class="border bg-white p-2 mt-2 h-100">
                    <h6>
                        <span v-if="advantagePayer.name">{{ advantagePayer.payer }}: {{ advantagePayer.name }}</span>
                        <span v-if="advantagePayer.insurance_type">, {{ advantagePayer.insurance_type }}</span>
                    </h6>
                    <a :href="`http://${advantagePayer.url}`" target="_blank" class="my-1" v-if="advantagePayer.url">{{
                        advantagePayer.url
                    }}</a>
                    <p class="my-1" v-if="advantagePayer.reference_id">
                        {{ advantagePayer.reference_id_qualifier }}: {{ advantagePayer.reference_id }}
                    </p>
                    <p class="my-1" v-if="advantagePayer.date">
                        <i class="fas fa-calendar-alt"></i> {{ advantagePayer.date }}
                    </p>
                    <p
                        class="my-1"
                        v-if="
                            advantagePayer.address1 || advantagePayer.city || advantagePayer.state || advantagePayer.zip
                        "
                    >
                        <i class="fas fa-address-book"></i>
                        {{ advantagePayer.address1 }}, {{ advantagePayer.city }}, {{ advantagePayer.state }},
                        {{ advantagePayer.zip }}
                    </p>
                    <p class="my-1" v-if="advantagePayer.phone">
                        <i class="fas fa-mobile-alt"></i>
                        <a :href="`tel:${advantagePayer.phone}`">{{ formatPhoneNumber(advantagePayer.phone) }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { formatPhoneNumber } from "../../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    props: {
        eligibility: {
            type: Object
        }
    },
    data() {
        return {
            formatPhoneNumber
        };
    }
});
</script>
